<template>

    <div id="page">
        <div class="container-fluid page-styling site-header-before">
            <div class="row">
                <div class="col-lg-4">
                    <ul class="links_list links_list-align-left align-center-desktop topbar-social">
                        <li>
                            <p class="links_list-value">
                                <a href="https://www.facebook.com/papelerialavictoria/" target="_blank" rel="nofollow">
                                <i class="fa fa-facebook" title="Encuentranos en Facebook"></i>
                                </a>
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-8">
                    <ul class="links_list links_list-align-right align-center-desktop topbar-contacts">
                        <li>
                            <p class="links_list-label">
                                Contáctanos
                            </p>
                            <p class="links_list-value">
                                <a href="mailto:raulcyan@gmail.com">raulcyan@gmail.com</a>
                            </p>
                        </li>
                        <li>
                            <p class="links_list-label">
                                <a v-if="$page.auth.check" href="/system">{{ $page.auth.user.name }}</a>
                                <a v-else href="/login">Iniciar sesión</a>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="site-header sticky top-0 z-10">
            <p class="h-logo">
                <inertia-link href="/"><img src="/images/logo_papeleria_la_victoria.png" :alt="`Logo ${$page.config.app.name}`" :title="`${$page.config.app.name}`"></inertia-link>
            </p><!--
                No Space
         --><div class="h-shop">
                <form method="get" action="#" class="h-search" id="h-search">
                    <input type="text" placeholder="Buscar...">
                    <button type="submit"><i class="ion-search"></i></button>
                </form>
                <ul class="h-shop-links">
                    <cart-widget></cart-widget>
                    <li class="h-menu-btn" id="h-menu-btn">
                        <i class="ion-navicon"></i> Menu
                    </li>
                </ul>
            </div><!--
                No Space
         --><div class="mainmenu">
                <nav id="h-menu" class="h-menu">
                    <ul>
                        <li :class="isCurrentPath('/') ? 'active' : ''">
                            <inertia-link href="/">Inicio</inertia-link>
                            <!-- <ul class="sub-menu">
                                <li class="active">
                                    <a href="index.html">Home 1</a>
                                </li>
                                <li>
                                    <a href="index-2.html">Home 2</a>
                                </li>
                                </ul> -->
                        </li>
                        <li :class="currentPathContains('/productos') ? 'active' : ''" class="menu-item-has-children">
                            <inertia-link href="/productos">Productos</inertia-link>
                            <ul class="sub-menu">
                                <li v-for="category in $page.categories" :key="category.id" :class="currentPathContains(category.slug) ? 'active': ''">
                                    <inertia-link :href="`/categorias/${category.slug}/productos`">{{ category.name }}</inertia-link>
                                </li>
                            </ul>
                        </li>
                        <li :class="isCurrentPath('/contacto')">
                            <a href="/contacto">Contacto</a>
                        </li>
                    </ul>
                </nav>
            </div><!--
                No Space
     --></div>


        <div id="content" class="site-content">
            <div class="container">
                <!-- @include('flash::message') -->
            </div>

            <slot :isCurrentPath="isCurrentPath" :currentPathContains="currentPathContains"></slot>

        </div>


        <div class="container-fluid blog-sb-widgets page-styling site-footer">
            <div class="row">
                <div class="col-sm-12 col-md-4 col-md-offset-1 widget align-center-tablet f-logo-wrap text-center">
                    <a href="/" class="f-logo">
                        <img src="/images/logo_papeleria_la_victoria.png" :alt="`Logo ${$page.config.app.name} `" :title="`Logo ${$page.config.app.name} `">
                    </a>
                    <p>Suministros de Papelería y Computación</p>
                    <a class="btn" style="color:white;" href="/contacto">Contacto</a>
                </div>
                <div class="col-xs-6 col-sm-3 col-md-2 align-center-mobile widget">
                    <h3 class="widgettitle">Nosotros</h3>
                    <ul class="menu">
                        <li>
                            <inertia-link href="/productos">Productos</inertia-link>
                        </li>
                        <li>
                            <a href="/contacto">Contactos</a>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-6 col-sm-3 col-md-3 align-center-mobile widget">
                    <h3 class="widgettitle">Encuéntranos</h3>
                    <p><i class="fa fa-envelope"></i> <a href="mailto:raulcyan@gmail.com">raulcyan@gmail.com</a></p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import CartWidget from '../components/Cart/CartWidget';

export default {
    props: {
      title: String,
    },

    components: {
        CartWidget,
    },

    mounted() {
        this.reloadSiteScripts();
        if (typeof INIT_PRODUCTS_SLIDES === "function") {
            INIT_PRODUCTS_SLIDES();
        }
    },

    methods: {
        isCurrentPath(path) {
            return window.location.pathname == path;
        },

        currentPathContains(subpath) {
            return (window.location.pathname.indexOf(subpath) > -1) ? true : false;
        },

        reloadSiteScripts() {
            var oldScript = null;
            if (oldScript = document.getElementById('site-scripts')) {
                oldScript.remove();
            };

            var script = document.createElement('script');
            script.src = "/js/site.js";
            script.id = "site-scripts";
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    },
    watch: {
      title: {
        immediate: true,
        handler(title) {
          document.title = title + ' - ' + this.$page.config.app.name;
        },
      },
    },
}
</script>

<style>

</style>
